import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import createComponent, { Component, Root, sstyled } from 'intergalactic/core';
import addonTextChildren from 'intergalactic/utils/lib/addonTextChildren';
import ChevronDown from 'intergalactic/icon/ChevronDown/m';
import BaseTrigger from './BaseTrigger';
import Spin from 'intergalactic/spin';
import animatedSizeEnhance from 'intergalactic/utils/lib/enhances/animatedSizeEnhance';
import { cssVariableEnhance } from 'intergalactic/utils/lib/useCssVariable';
/*__reshadow-styles__:"./style/button-trigger.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SButtonAddon_1ljne_gg_{width:12px;height:12px}.___SButtonTriggerSpin_1ljne_gg_{fill:var(--intergalactic-icon-primary-neutral, #6c6e79)}" /*__inner_css_end__*/, "1ljne_gg_") /*__reshadow_css_end__*/, {
  "__SButtonAddon": "___SButtonAddon_1ljne_gg_",
  "__SButtonTriggerSpin": "___SButtonTriggerSpin_1ljne_gg_"
});
var RootButtonTrigger = /*#__PURE__*/function (_Component) {
  _inherits(RootButtonTrigger, _Component);
  var _super = _createSuper(RootButtonTrigger);
  function RootButtonTrigger() {
    _classCallCheck(this, RootButtonTrigger);
    return _super.apply(this, arguments);
  }
  _createClass(RootButtonTrigger, [{
    key: "getTextProps",
    value: function getTextProps() {
      return {
        tag: 'span'
      };
    }
  }, {
    key: "getAddonProps",
    value: function getAddonProps() {
      return {
        tag: 'span'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps,
        _ref2;
      var SButtonAddon = ButtonTrigger.Addon;
      var SButtonTriggerSpin = Spin;
      var _this$asProps = this.asProps,
        Children = _this$asProps.Children,
        styles = _this$asProps.styles,
        loading = _this$asProps.loading,
        chevron = _this$asProps.chevron,
        empty = _this$asProps.empty;
      return _ref2 = sstyled(styles), /*#__PURE__*/React.createElement(BaseTrigger, _assignProps({
        "tag": 'button',
        "type": 'button'
      }, _ref), addonTextChildren(Children, ButtonTrigger.Text, ButtonTrigger.Addon, empty), (chevron || loading) && /*#__PURE__*/React.createElement(SButtonAddon, _ref2.cn("SButtonAddon", {}), loading ? /*#__PURE__*/React.createElement(SButtonTriggerSpin, _ref2.cn("SButtonTriggerSpin", {
        "size": 'xs',
        "theme": false
      })) : /*#__PURE__*/React.createElement(ChevronDown, _ref2.cn("ChevronDown", {}))));
    }
  }]);
  return RootButtonTrigger;
}(Component);
_defineProperty(RootButtonTrigger, "displayName", 'ButtonTrigger');
_defineProperty(RootButtonTrigger, "style", style);
_defineProperty(RootButtonTrigger, "enhance", [cssVariableEnhance({
  variable: '--intergalactic-duration-control',
  fallback: '200',
  map: Number.parseInt,
  prop: 'duration'
}), animatedSizeEnhance({
  animateProps: ['width'],
  onChangeOf: ['value']
})]);
_defineProperty(RootButtonTrigger, "defaultProps", {
  chevron: true
});
var ButtonTrigger = createComponent(RootButtonTrigger, {
  Text: BaseTrigger.Text,
  Addon: BaseTrigger.Addon
}, {
  parent: BaseTrigger
});
export default ButtonTrigger;
//# sourceMappingURL=ButtonTrigger.js.map